import { PricePeriodEdit } from '@features/TimberBuyer/SalesAgreements/PricePeriods/Edit/PricePeriodEdit'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const PricePeriodEditRoute: React.FC = () => {
  const { timberBuyerId, salesAgreementId, pricePeriodId } = Route.useParams()

  return (
    <PricePeriodEdit
      timberBuyerId={timberBuyerId}
      salesAgreementId={salesAgreementId}
      pricePeriodId={pricePeriodId}
    />
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/',
)({
  component: PricePeriodEditRoute,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-priceperiods.edit.breadcrumb'),
  },
})
